import React from 'react';
import './dataset-management.scss';
export interface DatasetManagementProps {

}

export const DatasetManagement = () => {
    return (
        <div className={'dataset-wrapper'}>
        </div>
    )
}
